import { Injectable } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot } from "@angular/router";
import { Course } from "../Models/course.model";
import { Observable } from "rxjs/Observable";
import { CourseService } from "../Services/course.service";

@Injectable()
export class AllCoursesResolver implements Resolve<Course[]>{  
    constructor(
        private _courseService: CourseService,
    ){}

    public resolve(route: ActivatedRouteSnapshot): Observable<Course[]>{
        return this._courseService.getAllCourses();
    }
}


// WEBPACK FOOTER //
// ./src/app/resolvers/allcourses.resolver.ts